import { useBuilderState } from '../../hooks/useBuilderState';

export const DesignInfo = () => {
  const { designName, designDescription, setDesignName, setDesignDescription } = useBuilderState();

  return (
    <div className="flex flex-col px-2.5 py-2 pb-2.5">
      <input
        type="text"
        value={designName}
        onChange={(e) => setDesignName(e.target.value)}
        className="w-full text-[13px] font-semibold text-[#1a1a1a] bg-transparent focus:outline-none rounded px-1 -mx-1 hover:bg-[#f0f0f0] focus:bg-[#f0f0f0] transition-colors py-0.5 leading-snug"
        placeholder="Untitled design"
      />
      <textarea
        value={designDescription}
        onChange={(e) => setDesignDescription(e.target.value)}
        className="w-full mt-1 text-[11px] text-[#888] bg-transparent resize-none focus:outline-none focus:text-[#555] transition-colors placeholder:text-[#bbb] leading-relaxed rounded px-1 -mx-1 hover:bg-[#f0f0f0] focus:bg-[#f0f0f0]"
        placeholder="Add a description…"
        rows={2}
      />
    </div>
  );
};
